import { EntityTypes } from './enums/entityTypes';

export interface AssessmentRubric {
  rubricId: string;
  assessmentId: string;
  entityType: EntityTypes.assessmentRubric;
  weighting: ScoreWeighting;
  scoring: ScoringHolder;
  created: number;
  lastUpdated: number;
}

export interface ScoreWeighting {
  [key: string]: Weight;
}

export interface Weight {
  [key: string]: number;
}

export interface ScoringHolder {
  [key: string]: AssessmentQuestionScoring;
}

export interface AssessmentQuestionScoring {
  id: number;
  points: number;
  format: string;
  type: string;
}
